import { ROUTES_PUBLIC } from "./routesMap.js";

const {
    Principal,
    Usuarios,
    Comunicados,
    Intereses,
    GuiasComerciales,
    Incidencias,
    Encuestas,
    Reservas,
    Pedidos,
    RedesInformacion,
    Agenda,
    Noticias,
} = await import('../views/index.js');

export const routesConfig = [
    { 
        path: ROUTES_PUBLIC.base,
        element: <Principal />,
    },
    { 
        path: ROUTES_PUBLIC.usuarios,
        element: <Usuarios />,
    },
    { 
        path: ROUTES_PUBLIC.comunicados,
        element: <Comunicados />,
    },
    { 
        path: ROUTES_PUBLIC.grupos_interes,
        element: <Intereses />,
    },
    { 
        path: ROUTES_PUBLIC.guias_comerciales,
        element: <GuiasComerciales />,
    },
    { 
        path: ROUTES_PUBLIC.incidencias,
        element: <Incidencias />,
    },
    { 
        path: ROUTES_PUBLIC.encuestas,
        element: <Encuestas />,
    },
    { 
        path: ROUTES_PUBLIC.reservas,
        element: <Reservas />,
    },
    { 
        path: ROUTES_PUBLIC.pedidos,
        element: <Pedidos />,
    },
    { 
        path: ROUTES_PUBLIC.redes_informacion,
        element: <RedesInformacion />,
    },
    { 
        path: ROUTES_PUBLIC.agenda,
        element: <Agenda />,
    },
    { 
        path: ROUTES_PUBLIC.noticias,
        element: <Noticias />,
    },
];